/**
 * ルーティング定数クラス
 * アプリケーション全体で使用されるルートパスとルート名を定義
 * 顧客向けの予約フローに関連する全てのルートを含む
 */
export default class RouterConstants {
  /** 顧客向けルートのベースパス */
  static CUSTOMER_ROOT_PATH = "/customer";
  /** 予約フローのベースパス */
  static BOOKING_ROUTER_PATH = `${this.CUSTOMER_ROOT_PATH}/bookings`;
  /** メニュー選択画面のパス */
  static BOOKING_MENU_ROUTER_PATH = `${this.BOOKING_ROUTER_PATH}/menus`;
  /** メニューカテゴリー選択画面のパス */
  static BOOKING_MENU_CATEGORY_ROUTER_PATH = `${this.BOOKING_ROUTER_PATH}/menu-categories`;
  /** オプション選択画面のパス */
  static BOOKING_OPTION_ROUTER_PATH = `${this.BOOKING_ROUTER_PATH}/options`;
  /** カレンダー画面のパス */
  static BOOKING_CALENDAR_ROUTER_PATH = `${this.BOOKING_ROUTER_PATH}/calendar`;
  /** 個人情報入力画面のパス */
  static PERSONAL_INFO_ROUTER_PATH = `${this.BOOKING_ROUTER_PATH}/personal-info`;
  /** 子供予約情報入力画面のパス */
  static CHILD_BOOKING_INFO_ROUTER_PATH = `${this.BOOKING_ROUTER_PATH}/child-booking`;
  /** 内容確認画面のパス */
  static CONTENT_CONFIRMATION_ROUTER_PATH = `${this.BOOKING_ROUTER_PATH}/content-confirmation`;
  /** 予約完了画面のパス */
  static BOOKING_SUCCESS_ROUTER_PATH = `${this.BOOKING_ROUTER_PATH}/booking-success`;
  /** 予約キャンセル完了画面のパス（予約IDを含む） */
  static BOOKING_CANCEL_SUCCESS_ROUTER_PATH = `${this.CUSTOMER_ROOT_PATH}/booking-cancel-success/:booking_id`;
  /** 予約履歴画面のパス */
  static BOOKING_HISTORY_ROUTER_PATH = `${this.CUSTOMER_ROOT_PATH}/booking-history`;
  /** 顧客情報画面のパス */
  static CUSTOMER_INFOS_ROUTER_PATH = `${this.CUSTOMER_ROOT_PATH}/infos`;
  /** 予約プレビュー画面のパス */
  static BOOKING_PREVIEW_ROUTER_PATH = `${this.BOOKING_ROUTER_PATH}/preview`;
  /** OTP認証フォームのパス */
  static OTP_FORM_PATH = `${this.CUSTOMER_ROOT_PATH}/otp`;
  /** 顧客向けルートの名前 */
  static CUSTOMER_ROUTER_NAME = "Customer";
  /** 予約フローの名前 */
  static BOOKING_ROUTER_NAME = "Customer Bookings";
  /** メニュー選択画面の名前 */
  static BOOKING_MENU_ROUTER_NAME = "Customer Menu Bookings";
  /** メニューカテゴリー選択画面の名前 */
  static BOOKING_MENU_CATEGORY_ROUTER_NAME = "Customer Menu Category Bookings";
  /** オプション選択画面の名前 */
  static BOOKING_OPTION_ROUTER_NAME = "Customer Option Bookings";
  /** カレンダー画面の名前 */
  static BOOKING_CALENDAR_ROUTER_NAME = "Customer Calendar Bookings";
  /** 個人情報入力画面の名前 */
  static PERSONAL_INFO_ROUTER_NAME = "Personal Information";
  /** 子供予約情報入力画面の名前 */
  static CHILD_BOOKING_INFO_ROUTER_NAME = "Child Booking Information";
  /** 内容確認画面の名前 */
  static CONTENT_CONFIRMATION_ROUTER_NAME = "Content Confirmation";
  /** 予約完了画面の名前 */
  static BOOKING_SUCCESS_ROUTER_NAME = "Booking Success";
  /** 予約キャンセル完了画面の名前 */
  static BOOKING_CANCEL_SUCCESS_ROUTER_NAME = "Booking Cancel Success";
  /** 予約履歴画面の名前 */
  static BOOKING_HISTORY_ROUTER_NAME = "Booking History";
  /** 顧客情報画面の名前 */
  static CUSTOMER_INFOS_ROUTER_NAME = "Customer Infos";
  /** 予約プレビュー画面の名前 */
  static BOOKING_PREVIEW_ROUTER_NAME = "Customer Booking Preview";
  /** OTP認証フォームの名前 */
  static OTP_FORM_NAME = "OTP Form";
}
